import { render, staticRenderFns } from "./meineProjekte.vue?vue&type=template&id=0e22fb10&"
import script from "./meineProjekte.vue?vue&type=script&lang=js&"
export * from "./meineProjekte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports